// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".js?h=" + "be5b1066f1a0dfb41eac" + "";
};